<template>
  <section>
    <b-field v-if="!isDetail" custom-class="mb-4px" class="mb-20">
      <template v-if="showLabel" slot="label">
        <p :class="classLabel">
          {{$t('general.devis')}}
        </p>
      </template>
      <b-input
        type="text"
        :value="recomLibelle"
        :class="{
          'is-min-width-300px': recommandation.issueRenouvellement,
          inputSociete: isPanier,
        }"
        expanded
        disabled>
      </b-input>
    </b-field>
    <div v-else>
      <p v-if="showLabel" class="has-text-grid-1 has-text-weight-bold is-size-14px pb-10">
        {{$t('general.devis')}}
      </p>
      <div class="card pa-10 mb-10">
        {{ recomLibelle }}
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    recommandation: {
      type: Object,
      required: true,
    },
    isPanier: {
      type: Boolean,
      default: false,
      required: false,
    },
    showLabel: {
      type: Boolean,
      default: false,
      required: false,
    },
    classLabel: {
      type: String,
      default: 'has-text-default is-size-7',
      required: false,
    },
    isDetail: {
      type: Boolean,
      default: false,
      required: false,
    }
  },
  computed: {
    recomLibelle() {
      const libelle = [this.recommandation.code];
      if (this.recommandation.issueRenouvellement) {
        libelle.push(`(${this.$t('general.renouvellement')})`)
      }
      return libelle.filter(Boolean).join(' ');
    }
  },
};
</script>
